export default __webpack_public_path__ + "static/media/PuntoAzul.b277f9e1.png";